import _ from 'lodash'
import React, { Component, Fragment } from 'react';
import classnames from 'classnames'
import { __ } from '@wordpress/i18n';

const pageBufferSize = 2; // 顯示前後兩頁
export default class Pagination extends Component {
  onClick = (e, page) => {
    e.preventDefault()
    this.props.onChange && this.props.onChange(page, _.get(this, 'props.pageSize',10))
  }
  getLargestPage = () => {
    const pageSize = _.get(this, 'props.pageSize', 10)
    const total = _.get(this, 'props.total')
    return Math.ceil(total / pageSize)
  }
  // 要出現的ITEM
  getPageRange = (page) => {
    const pageRange = []
    const largestPage = this.getLargestPage()
    
    var i = (page + pageBufferSize) < largestPage ? page : page - pageBufferSize
    i = (i - pageBufferSize) > 0 ? i - pageBufferSize : 1
    while (pageRange.length < 1 + (2 * pageBufferSize) && i <= largestPage) {
      pageRange.push(i++)
    }
    if (pageRange.length === 0 && page) {
      pageRange.push(page)
    }
    return pageRange
  }
  hasPrevEllipsis(page) {
    return page - (pageBufferSize + 1) > 0
  }
  hasNextEllipsis(page) {
    return page + (pageBufferSize + 1) < this.getLargestPage()
  }
  
  render() { 
    var current = _.get(this,'props.current')
    const pageSize = _.get(this,'props.pageSize',10)
    const total = _.get(this,'props.total', 0)
    const largestPage = Math.ceil(total/pageSize)
    if (current > largestPage) current = largestPage
    if (!total || total === 0) return <Fragment></Fragment>
    return (
      <Fragment>
        <nav class="mt-5" aria-label="Page navigation">
          <ul class="pagination justify-content-center">
            <li className={classnames('page-item', current <= 1 && 'disabled')}><a class="page-link" tabindex="-1" aria-disabled="true" onClick={e => this.onClick(e, current - 1)}><div class="fas fa-caret-left d-md-none"></div><span class="d-none d-md-inline">{__('上一頁','cec-plugin-stores')}</span></a></li>
            { this.hasPrevEllipsis(current) && 
              <Fragment>
                <li className={classnames('page-item', current === 1 && 'active')}><a class="page-link" href="#" onClick={e => this.onClick(e, 1)}>1</a></li>
                <li className="page-item"><span>•••</span></li>
              </Fragment>
            }
            {_.map(this.getPageRange(current), (page,idx) => (
              <li className={classnames('page-item', current === page && 'active')}><a class="page-link" href="#" onClick={e => this.onClick(e, page)}>{page}</a></li>
            ))}
            { this.hasNextEllipsis(current) && 
              <Fragment>
                <li className="page-item"><span>•••</span></li>
                <li className={classnames('page-item', current === largestPage && 'active')}><a class="page-link" href="#" onClick={e => this.onClick(e, largestPage)}>{largestPage}</a></li>
              </Fragment>
            }
            <li className={classnames('page-item', current >= largestPage && 'disabled')}><a class="page-link" href="#" onClick={e => this.onClick(e, current+1)}><div class="fas fa-caret-right d-md-none"></div><span class="d-none d-md-inline">{__('下一頁','cec-plugin-stores')}</span></a></li>
          </ul>
        </nav>
      </Fragment>
    )
    
  }
}



// WEBPACK FOOTER //
// ./src/components/Pagination/Pagination.js